import { create } from "zustand";
import type { HelpScope } from "@fysaro/shared";

interface HelpDrawerState {
  isOpen: boolean;
  scope: HelpScope;
  activeArticleId: string | null;
  openHelp: (scope?: HelpScope, helpArticleId?: string | null) => void;
  closeHelp: () => void;
}

export const useHelpDrawer = create<HelpDrawerState>((set) => ({
  isOpen: false,
  scope: "TENANT",
  activeArticleId: null,
  openHelp: (scope = "TENANT", helpArticleId = null) =>
    set({ isOpen: true, scope, activeArticleId: helpArticleId }),
  closeHelp: () => set({ isOpen: false, activeArticleId: null }),
}));